<template>
  <v-dialog
    v-model="showDialog"
    :fullscreen="fullscreen"
    :width="width"
    :maxWidth="maxWidth"
    :persistent="persistent"
    :no-click-animation="noClickAnimation"
    :scrollable="scrollable"
    @click:outside="close"
  >
    <!-- <v-card color="bodyBG" tile class="pt-9 px-lg-12 pb-12"> -->
    <v-card color="bodyBG" tile class="pt-9 px-lg-12 pb-2">
      <slot name="title">
        <!-- back navigation button -->
        <!-- <v-btn
          v-if="dialogBack"
          depressed
          class="ma-2"
          fab
          outlined
          color="primary"
          @click.stop="closeDialog"
        >
          <v-icon dark color="primary">{{ dialogBack }}</v-icon>
        </v-btn> -->

        <v-card-title
          class="headline flex-column text-center primary--text mb-1 safeAreaTop fixTitle"
        >
          <v-avatar v-if="dialogIcon" class="mb-1" size="48" color="primary">
            <v-icon dark>{{ dialogIcon }}</v-icon>
          </v-avatar>
          {{ title }}
        </v-card-title>
        <v-card-subtitle
          v-if="subtitle"
          class="subtitle primaryText--text text-center"
        >
          {{ subtitle }}
        </v-card-subtitle>
      </slot>

      <v-card-text>
        <slot></slot>
      </v-card-text>

      <v-card-actions
        class="justify-center safeAreaBottom"
        :class="{ columnDirection: actionsColumnDirection }"
      >
        <slot name="btn"></slot>
        <v-btn
          v-if="btnActionName"
          class="px-12 py-5"
          color="primary"
          depressed
          @click.stop="$emit('action')"
        >
          {{ btnActionName }}
        </v-btn>
        <v-btn
          v-if="!persistent || showCloseBtn"
          class="px-8 py-5"
          :class="{ 'ml-0': closeBtnBlock }"
          :color="btnCloseColor"
          depressed
          :block="closeBtnBlock"
          @click.stop="closeDialog"
        >
          {{ btnCloseName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    dialogBack: {
      type: String,
      default: null,
    },
    dialogIcon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    btnCloseName: {
      type: String,
      default: "Lukk",
    },
    btnCloseColor: {
      type: String,
      default: "cardBtnBadge",
    },
    btnActionName: {
      type: String,
      default: null,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    noClickAnimation: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    width: {
      default: 512,
    },
    maxWidth: {
      default: null,
    },
    actionsColumnDirection: {
      type: Boolean,
      default: false,
    },
    closeBtnBlock: {
      type: Boolean,
      default: false,
    },
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
    removeFullscreen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      if (!this.persistent) {
        this.$emit("close");
        this.showDialog = false;
      }
    },
    closeDialog() {
      this.$emit("close");
      this.showDialog = false;
    },
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    fullscreen(): boolean {
      if (this.removeFullscreen) {
        return false;
      } else {
        return this.$vuetify.breakpoint.xs;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.columnDirection {
  flex-direction: column;
}
.fixTitle {
  word-break: break-word;
}
</style>

<style lang="scss">
.safeAreaTop {
  padding-top: calc(16px + env(safe-area-inset-top)) !important;
}
.safeAreaBottom {
  padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;
}
</style>
